import React from 'react';

const SvgPinterest = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    {...props}
  >
    <path
      d="M8.5 0C4.08 0 .5 3.58.5 8c0 3.39 2.11 6.29 5.09 7.46-.07-.64-.13-1.61.03-2.3.14-.63.93-3.95.93-3.95s-.24-.47-.24-1.17c0-1.1.64-1.92 1.43-1.92.68 0 1 .51 1 1.12 0 .68-.43 1.7-.66 2.64-.19.79.4 1.43 1.17 1.43 1.41 0 2.49-1.49 2.49-3.63 0-1.9-1.36-3.22-3.31-3.22-2.26 0-3.58 1.69-3.58 3.44 0 .68.26 1.41.59 1.81.06.08.07.15.05.23-.06.25-.2.79-.22.9-.03.15-.11.18-.26.11-.98-.46-1.59-1.89-1.59-3.04 0-2.48 1.8-4.75 5.2-4.75 2.73 0 4.85 1.94 4.85 4.54 0 2.71-1.71 4.89-4.08 4.89-.8 0-1.55-.41-1.81-.9l-.49 1.88c-.18.68-.66 1.54-.99 2.06A8 8 0 0 0 8.5 16c4.42 0 8-3.58 8-8s-3.58-8-8-8Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgPinterest;
